import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import {PriceRobotCompetitor} from "./price-robot-competitor";
import {PriceRobotUrl} from "./price-robot-url";
import {PriceRobotFilter} from "./price-robot-filter";
import {environment} from "../../environments/environment";
import {AuthService, BaseService} from "@hassel-it/angular-common";

@Injectable({
    providedIn: 'root'
})
export class PriceRobotCrawlerUrlService extends BaseService {

    constructor(public http: HttpClient, public authService: AuthService) {
        super(http, authService);
    }

    enqueue(id) {
        this.reloadHeaders();

        // let myParams = new HttpParams();
        return this.http.post(environment.apiBase + '/admin/crawler/crawler-urls/enqueue/' + id, null, {
            headers: this.httpHeaders,
            // params: myParams
        });

    }
}
